import { useEffect } from 'react';

export default function StructuredData() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'structured-data';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Clarity - Psihološko savetovalište",
      "image": "https://claritypsiholog.com/images/logo-bird.webp",
      "@id": "https://claritypsiholog.com",
      "url": "https://claritypsiholog.com",
      "telephone": "+381603898789",
      "email": "clarity.psiholog@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Novi Sad",
        "addressRegion": "Vojvodina",
        "addressCountry": "RS"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 45.267136,
        "longitude": 19.833549
      },
      "description": "Psiholog Novi Sad - Profesionalna psihološka pomoć u Novom Sadu. Psihoterapija, savetovanje, testiranje i podrška za pojedince i kompanije.",
      "sameAs": [
        "https://www.linkedin.com/company/psiholo%C5%A1ki-centar-clarity/"
      ],
      "areaServed": {
        "@type": "City",
        "name": "Novi Sad"
      },
      "serviceType": [
        "Psihoterapija",
        "Psihološko savetovanje",
        "Psihološka procena i testiranje",
        "Intervencija u krizi",
        "Neurodivergentnost podrška"
      ]
    });
    document.head.appendChild(script);

    return () => {
      const existingScript = document.getElementById('structured-data');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return null;
}
